import React from 'react';
import type { NumberedListBlock } from '../../types';

export interface NumberedListBlockViewProps {
  block: NumberedListBlock;
}

export function NumberedListBlockView({ block }: NumberedListBlockViewProps): React.ReactElement {
  return (
    <ol data-testid="block-numbered_list" className="list-decimal pl-4 space-y-0.5 text-[14px] font-normal text-text-primary">
      {block.items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ol>
  );
}
